import { defineMessages } from 'react-intl'

export default defineMessages({
  addMember: {
    id: 'SpaceMembersPage.ManageUserRole.Search',
    defaultMessage: 'Add Member'
  },
  blank: {
    id: 'SpaceMembersPage.ManageUserRole.Blank',
    defaultMessage: 'Select a role...'
  },
  searchPlaceholder: {
    id: 'SpaceMembersPage.ManageUserRole.Search.Placeholder',
    defaultMessage: 'Member Name'
  },
  selectRole: {
    id: 'SpaceMembersPage.ManageUserRole.Select',
    defaultMessage: 'Select a role to manage'
  },
  title: {
    id: 'SpaceMembersPage.ManageUserRole.LongLabel',
    defaultMessage: 'Manage User Roles'
  }
})
